<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Tariff Rate</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Tariff Rate</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Existing Tariff Rate</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.busCls }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.busCls + " - " + tariffFactId.busClsDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.tariff }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.tariff + " - " + tariffFactId.tariffDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.benefit }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.benefit + " - " + tariffFactId.benDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.seqNo }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.seqNo }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <cal-picker
                  v-model="tariffRateForm.effDate"
                  :label="tariffRateLabel.effDate"
                  :data-vv-as="tariffRateLabel.effDate"
                  data-vv-name="tariffRateForm.effDate"
                  :error-messages="errors.collect('tariffRateForm.effDate')"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffRateLabel.effDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffRateForm.effDate) }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <cal-picker
                  v-model="tariffRateForm.expDate"
                  :label="tariffRateLabel.expDate"
                  :data-vv-as="tariffRateLabel.expDate"
                  data-vv-name="tariffRateForm.expDate"
                  :error-messages="errors.collect('tariffRateForm.expDate')"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffRateLabel.expDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffRateForm.expDate) }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="newMode">
              <v-flex xs6>
                <v-text-field
                  v-model="tariffRateForm.fact1"
                  :label="tariffRateLabel.fact1"
                  :error-messages="errors.collect('tariffRateForm.fact1')"
                  data-vv-name="tariffRateForm.fact1"
                  :data-vv-as="tariffRateLabel.fact1"
                  :disabled="this.tariffFactId.fact1 === null"
                  v-validate="fact1Validation"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="tariffRateForm.fact2"
                  :label="tariffRateLabel.fact2"
                  :error-messages="errors.collect('tariffRateForm.fact2')"
                  data-vv-name="tariffRateForm.fact2"
                  :data-vv-as="tariffRateLabel.fact2"
                  :disabled="this.tariffFactId.fact2 === null"
                  v-validate="fact2Validation"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="tariffRateForm.fact3"
                  :label="tariffRateLabel.fact3"
                  :error-messages="errors.collect('tariffRateForm.fact3')"
                  data-vv-name="tariffRateForm.fact3"
                  :data-vv-as="tariffRateLabel.fact3"
                  :disabled="this.tariffFactId.fact3 === null"
                  v-validate="fact3Validation"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="tariffRateForm.fact4"
                  :label="tariffRateLabel.fact4"
                  :error-messages="errors.collect('tariffRateForm.fact4')"
                  v-num-mask="{ negative: true, intScale: 10, decScale: 2 }"
                  data-vv-name="tariffRateForm.fact4"
                  :data-vv-as="tariffRateLabel.fact4"
                  :disabled="this.tariffFactId.fact4 === null"
                  v-validate="fact4Validation"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="tariffRateForm.fact5"
                  :label="tariffRateLabel.fact5"
                  :error-messages="errors.collect('tariffRateForm.fact5')"
                  v-num-mask="{ negative: true, intScale: 10, decScale: 2 }"
                  data-vv-name="tariffRateForm.fact5"
                  :data-vv-as="tariffRateLabel.fact5"
                  :disabled="this.tariffFactId.fact5 === null"
                  v-validate="fact5Validation"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="tariffRateForm.fact6"
                  :label="tariffRateLabel.fact6"
                  :error-messages="errors.collect('tariffRateForm.fact6')"
                  v-num-mask="{ negative: true, intScale: 10, decScale: 2 }"
                  data-vv-name="tariffRateForm.fact6"
                  :data-vv-as="tariffRateLabel.fact6"
                  :disabled="this.tariffFactId.fact6 === null"
                  v-validate="fact6Validation"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-else>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.fact1 }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.fact1 }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.fact2 }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.fact2 }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.fact3 }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.fact3 }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.fact4 }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.fact4 }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.fact5 }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.fact5 }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.fact6 }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.fact6 }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="!queryMode">
              <v-flex xs6>
                <v-text-field
                  ref="minAp"
                  v-model="tariffRateForm.minAp"
                  :label="tariffRateLabel.minAp"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.minAp')"
                  data-vv-name="tariffRateForm.minAp"
                  :data-vv-as="tariffRateLabel.minAp"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="maxAp"
                  v-model="tariffRateForm.maxAp"
                  :label="tariffRateLabel.maxAp"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.maxAp')"
                  data-vv-name="tariffRateForm.maxAp"
                  :data-vv-as="tariffRateLabel.maxAp"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="baseAp"
                  v-model="tariffRateForm.baseAp"
                  :label="tariffRateLabel.baseAp"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.baseAp')"
                  data-vv-name="tariffRateForm.baseAp"
                  :data-vv-as="tariffRateLabel.baseAp"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="baseSi"
                  v-model="tariffRateForm.baseSi"
                  :label="tariffRateLabel.baseSi"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.baseSi')"
                  data-vv-name="tariffRateForm.baseSi"
                  :data-vv-as="tariffRateLabel.baseSi"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="pctIncBaseAp"
                  v-model="tariffRateForm.pctIncBaseAp"
                  :label="tariffRateLabel.pctIncBaseAp"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.pctIncBaseAp')"
                  data-vv-name="tariffRateForm.pctIncBaseAp"
                  :data-vv-as="tariffRateLabel.pctIncBaseAp"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="insSi"
                  v-model="tariffRateForm.insSi"
                  :label="tariffRateLabel.insSi"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.insSi')"
                  data-vv-name="tariffRateForm.insSi"
                  :data-vv-as="tariffRateLabel.insSi"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="incApBase"
                  v-model="tariffRateForm.incApBase"
                  :label="tariffRateLabel.incApBase"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.incApBase')"
                  data-vv-name="tariffRateForm.incApBase"
                  :data-vv-as="tariffRateLabel.incApBase"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  ref="tariffRate"
                  v-model="tariffRateForm.tariffRate"
                  :label="tariffRateLabel.tariffRate"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('tariffRateForm.tariffRate')"
                  data-vv-name="tariffRateForm.tariffRate"
                  :data-vv-as="tariffRateLabel.tariffRate"
                  @blur="setValue()"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="queryMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.minAp }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.minAp }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.maxAp }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.maxAp }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.baseAp }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.baseAp }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.baseSi }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.baseSi }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.pctIncBaseAp }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.pctIncBaseAp }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.insSi }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.insSi }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.incApBase }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.incApBase }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.tariffRate }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.tariffRate }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.createdBy }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffRateLabel.createdDate }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.createdDate | formatDate }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffRateLabel.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffRateLabel.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ tariffRateForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>

            <v-spacer class="mt-3"></v-spacer>
            <v-layout>
              <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
                Cancel
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                Save
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import isAfter from 'date-fns/isAfter'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      tariffRateLabel: {
        busCls: 'Business Class',
        tariff: 'Tariff',
        benefit: 'Benefit',
        seqNo: 'Sequence No.',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6',
        minAp: 'Minimum AP',
        maxAp: 'Maximum AP',
        baseAp: 'Base AP',
        baseSi: 'Base SI',
        pctIncBaseAp: '% Increment Base AP',
        insSi: 'Increment on SI',
        incApBase: 'Increment AP on Base',
        tariffRate: 'Tariff Rate',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      tariffRateForm: {
        effDate: null,
        expDate: null,
        tariff: null,
        busCls: null,
        benefit: null,
        seqNo: '0',
        fact1: 'NA',
        fact2: 'NA',
        fact3: 'NA',
        fact4: '0.00',
        fact5: '0.00',
        fact6: '0.00',
        minAp: '0.00',
        maxAp: '0.00',
        baseAp: '0.00',
        baseSi: '0.00',
        pctIncBaseAp: '0.00',
        insSi: '0.00',
        incApBase: '0.00',
        tariffRate: '0.00',
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      }
    }
  },
  methods: {
    async doInit() {
      this.tariffRateForm.tariff = this.tariffFactId.tariff
      this.tariffRateForm.busCls = this.tariffFactId.busCls
      this.tariffRateForm.benefit = this.tariffFactId.benefit
      this.tariffRateForm.seqNo = this.tariffFactId.seqNo
      if (this.newTariffRate) {
        this.tariffRateForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.tariffRateForm.createdDate = new Date()
        this.tariffRateForm.effDate = new Date()
        this.tariffRateForm.expDate = this.tariffRateForm.effDate
      } else {
        this.fetchData()
      }
    },
    async fetchData() {
      const apiURI = this.menu.tariffRate
      if (apiURI) {
        try {
          const expand = {
            tariff: this.tariffRateId.tariff,
            busCls: this.tariffRateId.busCls,
            benefit: this.tariffRateId.benefit,
            seqNo: this.tariffRateId.seqNo,
            effDate: formatDisplayDateTime2(removeTime(this.tariffRateId.effDate)),
            fact1: this.tariffRateId.fact1,
            fact2: this.tariffRateId.fact2,
            fact3: this.tariffRateId.fact3,
            fact4: this.tariffRateId.fact4,
            fact5: this.tariffRateId.fact5,
            fact6: this.tariffRateId.fact6
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tariffRateForm.effDate = data.tarfRate.effDate
            this.tariffRateForm.expDate = data.tarfRate.expDate
            this.tariffRateForm.fact1 = data.tarfRate.fact1
            this.tariffRateForm.fact2 = data.tarfRate.fact2
            this.tariffRateForm.fact3 = data.tarfRate.fact3
            this.tariffRateForm.fact4 = data.tarfRate.fact4
            this.tariffRateForm.fact5 = data.tarfRate.fact5
            this.tariffRateForm.fact6 = data.tarfRate.fact6
            this.tariffRateForm.minAp = data.tarfRate.minAp
            this.tariffRateForm.maxAp = data.tarfRate.maxAp
            this.tariffRateForm.baseAp = data.tarfRate.baseAp
            this.tariffRateForm.baseSi = data.tarfRate.baseSi
            this.tariffRateForm.pctIncBaseAp = data.tarfRate.pctIncBaseAp
            this.tariffRateForm.insSi = data.tarfRate.insSi
            this.tariffRateForm.incApBase = data.tarfRate.incApBase
            this.tariffRateForm.tariffRate = data.tarfRate.tariffRate
            this.tariffRateForm.createdBy = data.createdBy
            this.tariffRateForm.createdDate = data.createdDate
            this.tariffRateForm.modifiedBy = data.modifiedBy
            this.tariffRateForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newTariffRate) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createTariffRate
      if (apiURI) {
        let messageFilters = clone(this.tariffRateForm)
        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        this.$http
          .post(apiURI, messageFilters)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'tarfRate' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateTariffRate
      if (apiURI) {
        this.submitting = true
        let messageFilters = clone(this.tariffRateForm)

        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }

        try {
          const result = await this.$http.put(apiURI, messageFilters)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'tarfRate' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    setValue() {
      this.$refs.minAp.$el.cleave.setRawValue(this.tariffRateForm.minAp)
      this.tariffRateForm.minAp = formatPrice(this.$refs.minAp.$el.cleave.getRawValue())
      this.$refs.maxAp.$el.cleave.setRawValue(this.tariffRateForm.maxAp)
      this.tariffRateForm.maxAp = formatPrice(this.$refs.maxAp.$el.cleave.getRawValue())
      this.$refs.baseAp.$el.cleave.setRawValue(this.tariffRateForm.baseAp)
      this.tariffRateForm.baseAp = formatPrice(this.$refs.baseAp.$el.cleave.getRawValue())
      this.$refs.baseSi.$el.cleave.setRawValue(this.tariffRateForm.baseSi)
      this.tariffRateForm.baseSi = formatPrice(this.$refs.baseSi.$el.cleave.getRawValue())
      this.$refs.pctIncBaseAp.$el.cleave.setRawValue(this.tariffRateForm.pctIncBaseAp)
      this.tariffRateForm.pctIncBaseAp = formatPrice(this.$refs.pctIncBaseAp.$el.cleave.getRawValue())
      this.$refs.insSi.$el.cleave.setRawValue(this.tariffRateForm.insSi)
      this.tariffRateForm.insSi = formatPrice(this.$refs.insSi.$el.cleave.getRawValue())
      this.$refs.incApBase.$el.cleave.setRawValue(this.tariffRateForm.incApBase)
      this.tariffRateForm.incApBase = formatPrice(this.$refs.incApBase.$el.cleave.getRawValue())
      this.$refs.tariffRate.$el.cleave.setRawValue(this.tariffRateForm.tariffRate)
      this.tariffRateForm.tariffRate = formatPrice(this.$refs.tariffRate.$el.cleave.getRawValue())
    },
    doCancel() {
      this.$router.push({ name: 'tarfRate' })
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('tariffRate'))
    this.$store.commit('TARIFF_RATE_COMMIT_KEY', jsonData)

    const jsonData2 = JSON.parse(sessionStorage.getItem('tariffFact'))
    this.$store.commit('TARIFF_FACTOR_COMMIT_KEY', jsonData2)

    if (this.tariffRateId.tarfFactMode !== '') {
      if (this.tariffRateId.tarfRateMode === 'New') {
        this.newMode = true
      } else if (this.tariffRateId.tarfRateMode === 'Review') {
        this.reviewMode = true
      } else if (this.tariffRateId.tarfRateMode === 'Query') {
        this.queryMode = true
      }
    }

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.tariffRateParam.menu
    },
    newTariffRate() {
      return this.tariffRateId.tarfRateMode === 'New'
    },
    tariffRateId() {
      return this.$store.state.tariffRateParam.tarfRate.tarfRateId
    },
    tariffFactId() {
      return this.$store.state.tariffFactorParam.tarfFact.tarfFactId
    },
    expDateValidation() {
      if (this.tariffRateForm.expDate !== '' && this.tariffRateForm.expDate !== null) {
        return 'entry|valExpiry:' + this.tariffRateForm.effDate
      } else {
        return ''
      }
    },
    fact1Validation() {
      if (this.tariffFactId.fact1 !== '' && this.tariffFactId.fact1 !== null) {
        if (this.tariffRateForm.fact1 === '' || this.tariffRateForm.fact1 === null) {
          return 'required'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    fact2Validation() {
      if (this.tariffFactId.fact2 !== '' && this.tariffFactId.fact2 !== null) {
        if (this.tariffRateForm.fact2 === '' || this.tariffRateForm.fact2 === null) {
          return 'required'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    fact3Validation() {
      if (this.tariffFactId.fact3 !== '' && this.tariffFactId.fact3 !== null) {
        if (this.tariffRateForm.fact3 === '' || this.tariffRateForm.fact3 === null) {
          return 'required'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    fact4Validation() {
      if (this.tariffFactId.fact4 !== '' && this.tariffFactId.fact4 !== null) {
        if (this.tariffRateForm.fact4 === '' || this.tariffRateForm.fact4 === null) {
          return 'required'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    fact5Validation() {
      if (this.tariffFactId.fact5 !== '' && this.tariffFactId.fact5 !== null) {
        if (this.tariffRateForm.fact5 === '' || this.tariffRateForm.fact5 === null) {
          return 'required'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    fact6Validation() {
      if (this.tariffFactId.fact6 !== '' && this.tariffFactId.fact6 !== null) {
        if (this.tariffRateForm.fact6 === '' || this.tariffRateForm.fact6 === null) {
          return 'required'
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin]
}
</script>
